import { gql } from 'apollo-boost';

export const SCAN_URL_VIDEO_TEXT = gql`
    mutation($data: ScanUrlVideoTextInput!) {
        scanUrlVideoText(data: $data) {
            id
        }
    }
`;
